import Box, { BoxProps } from '@mui/material/Box'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import BlankLayout from 'src/@core/layouts/BlankLayout'

const BoxWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '90vw'
  }
}))

const Img = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    height: 450,
    marginTop: theme.spacing(10)
  },
  [theme.breakpoints.down('md')]: {
    height: 400
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: theme.spacing(20)
  }
}))

const Error401 = () => {
  return (
    <BlankLayout>
      <Box className='content-center'>
        <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <BoxWrapper>
            <Typography variant='h4' sx={{ mb: 1.5 }}>
              You are not authorized!
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              You do not have permission to view this page using the credentials that you have provided while login.
            </Typography>
            <Typography sx={{ mb: 6, color: 'text.secondary' }}>Please contact your site administrator.</Typography>
            <Button to='/' component={Link} variant='contained'>
              Back to Home
            </Button>
          </BoxWrapper>
          <Img height='500' alt='error-illustration' src='/images/pages/401.png' />
        </Box>
      </Box>
    </BlankLayout>
  )
}

export default Error401
